import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 0 1fr;
  box-sizing: border-box;
`;

const InputField = styled.input`
  background-color: transparent;
  border: 1px solid ${props => props.theme.primary};
  height: 32.5px;
  border-radius: 33px;
  outline: none;
  color: ${props => props.theme.text};
  text-align: right;
  width: 100%;
  margin-bottom: 15px;
  padding: 0 10px 0 35px;
  box-sizing: border-box;
  ::placeholder {
    color: ${props => props.theme.text};
  }

  @media (min-width: 1800px) {
    border: 2px solid ${props => props.theme.primary};
    font-size: 21px;
    line-height: 36px;
    height: 40px;
    padding: 0 25px;
    margin-bottom: 30px;
  }

  @media (max-width: 575px) {
    font-size: 14px;
    line-height: 24px;
    height: 30px;
  }
`;

const Icon = styled.i`
  position: relative;
  left: 15px;
  top: 8px;
  cursor: pointer;
  z-index: 1;

  @media (min-width: 1800px) {
    left: 25px;
  }

  @media (max-width: 575px) {
    top: 6px;
  }
`;

const TextField = ({ placeholder, rounded, icon, ...props }) => {
  return rounded ? (
    <Wrapper>
      <Icon>{icon}</Icon>
      <InputField {...props} placeholder={placeholder} type="text" />
    </Wrapper>
  ) : (
    <label className="textfield">
      <input placeholder=" " {...props} />
      <span>{placeholder}</span>
    </label>
  );
};

export default TextField;
